import { graphql } from '../__generated__/gql';

export const GET_ALL_SH1S = graphql(/* GraphQL */ `
  query SH1s($assetId: Int!) {
    allSH1s(assetId: $assetId) {
      sh1Id
      sh1Number
      assetId
      createdBy
      updatedAt
      createdAt
      updatedAt
    }
  }
`);

export const CREATE_SH1 = graphql(/* GraphQL */ `
  mutation CreateSH1($input: SH1Input!) {
    createSH1(input: $input) {
      sh1Id
      sh1Number
      assetId
    }
  }
`);
